import { defineMessages } from 'react-intl-next';

export const messages: {
    placeholder: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	placeholder: {
		id: 'search_dialog_aria_label',
		defaultMessage: 'Search',
		description: 'Placeholder text in primary search input',
	},
});
